if (!customElements.get('livana-ingredient-slider')) {
  customElements.define('livana-ingredient-slider', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.lne-ingredients__track');
      const controls = this.querySelector('.lne-ingredients__arrows');
      const arrows = [...this.querySelectorAll('[data-ingredient-direction]')];
      if (!track || !controls || !arrows.length) return;

      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let positions = [];
      let active = 0;
      const update = () => {
        const position = Math.abs(track.scrollLeft);
        active = 0;
        positions.forEach((point, index) => {
          if (Math.abs(point - position) < Math.abs(positions[active] - position)) active = index;
        });
        arrows.forEach((arrow) => {
          const target = active + Number(arrow.dataset.ingredientDirection);
          arrow.disabled = target < 0 || target >= positions.length;
        });
      };
      const measure = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const cards = [...track.children];
        const first = cards[0].getBoundingClientRect().left;
        positions = cards.map(card => Math.min(maximum, Math.abs(card.getBoundingClientRect().left - first)))
          .filter((position, index, all) => index === 0 || position - all[index - 1] > 2);
        controls.hidden = positions.length < 2;
        update();
      };

      arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const sign = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          const target = positions[active + Number(arrow.dataset.ingredientDirection)];
          track.scrollTo({ left: target * sign, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }, { signal });
      });
      track.addEventListener('scroll', update, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(measure);
      this.resizeObserver.observe(track);
      measure();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
